module.exports = __webpack_public_path__ + "static/media/A28.09f2f1e2.png";